// Canonical Wasabi storage region data, sourced from internal infra docs.
// Used by the PentestCreate combobox to pre-populate name suggestions.

export const WASABI_VAULTS = [
  { region: 'us-east-1',      vault: 'prod1',  site: 'ashburn',   label: 'Ashburn',           location: 'USA (Virginia)' },
  { region: 'us-east-2',      vault: 'prod4',  site: 'mnx',       label: 'Manassas',          location: 'USA (Virginia)' },
  { region: 'us-west-1',      vault: 'prod2',  site: 'hillsboro', label: 'Hillsboro',         location: 'USA (Oregon)' },
  { region: 'us-central-1',   vault: 'prod6',  site: 'dfw1',      label: 'Plano',             location: 'USA (Plano)' },
  { region: 'eu-central-1',   vault: 'prod3',  site: 'ams',       label: 'Amsterdam',         location: 'Amsterdam' },
  { region: 'eu-central-2',   vault: 'prod10', site: 'fr2',       label: 'Frankfurt',         location: 'Germany (Frankfurt)' },
  { region: 'eu-south-1',     vault: 'prod14', site: 'ma3',       label: 'Milan',             location: 'Italy (Milan)' },
  { region: 'eu-west-1',      vault: 'prod8',  site: 'ld7',       label: 'London',            location: 'GB (London)' },
  { region: 'eu-west-2',      vault: 'prod9',  site: 'pa3',       label: 'Paris',             location: 'France (Paris)' },
  { region: 'ca-central-1',   vault: 'prod11', site: 'tr6',       label: 'Toronto',           location: 'Canada (Toronto)' },
  { region: 'ap-northeast-1', vault: 'prod5',  site: 'tk10',      label: 'Tokyo',             location: 'Japan (Tokyo)' },
  { region: 'ap-northeast-2', vault: 'prod7',  site: 'os7',       label: 'Osaka',             location: 'Japan (Osaka)' },
  { region: 'ap-southeast-1', vault: 'prod13', site: 'sg4',       label: 'Singapore',         location: 'Singapore' },
  { region: 'ap-southeast-2', vault: 'prod12', site: 'sy5',       label: 'Sydney',            location: 'Australia (Sydney)' },
];

// Canonical pen test name for a vault, matching the existing report title format
// e.g. "Wasabi Storage Region us-west-1 (Hillsboro)".
export function vaultDisplayName(vault) {
  return `Wasabi Storage Region ${vault.region} (${vault.label})`;
}

// Filter the catalog by free-text query against label/region/site/location.
export function filterVaults(query) {
  if (!query) return WASABI_VAULTS;
  const q = query.toLowerCase();
  return WASABI_VAULTS.filter((v) =>
    v.region.toLowerCase().includes(q) ||
    v.label.toLowerCase().includes(q) ||
    v.site.toLowerCase().includes(q) ||
    v.location.toLowerCase().includes(q) ||
    vaultDisplayName(v).toLowerCase().includes(q),
  );
}
